import React from "react";

const IndustrialIndustryLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#3a2d34] text-white">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <span className="text-sm uppercase text-gray-300">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4">
                            Re(AI)magining™ Industrial
                        </h1>
                        <p className="mt-6 text-gray-200 max-w-xl">
                            Enabling manufacturers and industrial enterprises to modernize
                            operations, accelerate innovation, and build data-driven factories.
                        </p>
                    </div>

                    <img
                        src="https://images.unsplash.com/photo-1581090700227-1e37b190418e"
                        alt="Industrial Automation"
                        className="rounded-xl shadow-lg"
                    />
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 text-gray-700 space-y-4">
                    <p>
                        Industrial organizations face increasing pressure to improve
                        efficiency, resilience, and sustainability while managing complex
                        global operations.
                    </p>
                    <p>
                        We help industrial enterprises unlock the power of AI, cloud, data,
                        and intelligent automation to transform manufacturing, energy, and
                        engineering ecosystems.
                    </p>
                </div>
            </section>

            {/* ================= INDUSTRIAL MANUFACTURING ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Industrial Manufacturing
                        </h2>
                        <p className="text-gray-700">
                            Drive operational excellence by integrating smart manufacturing,
                            digital twins, predictive maintenance, and intelligent supply
                            chains across factory ecosystems.
                        </p>

                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our industry expertise
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• Smart Factory Solutions</li>
                            <li>• Industrial IoT Platforms</li>
                            <li>• Asset Performance Management</li>
                            <li>• Manufacturing Execution Systems</li>
                            <li>• Digital Supply Chain</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= INDUSTRY 4.0 ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1581091215367-59ab6c38f2a4)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Transforming Factories into Intelligent Data Centers
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Implement Industry 4.0 strategies that connect machines, data, and
                        people to enable real-time visibility and smarter decision-making.
                    </p>
                </div>
            </section>

            {/* ================= SERVICE OFFERINGS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Service Offerings</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            "Application Development & Maintenance",
                            "Cloud & Infrastructure",
                            "Data & Analytics",
                            "Global Capability Centers",
                            "Intelligent Automation",
                            "OT Cybersecurity",
                            "Experience Transformation",
                            "Industrial Systems Integration",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-white rounded-xl shadow-sm p-6 text-sm font-medium"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= ACCELERATORS ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">
                        Our Solution & Technology Accelerators
                    </h2>

                    <div className="grid md:grid-cols-4 gap-6">
                        {[
                            "AI-Driven Predictive Maintenance",
                            "Digital Twin Frameworks",
                            "Connected Worker Platforms",
                            "Industrial AI Labs",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-[#020617] text-white rounded-xl p-6 text-sm"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            Enabling a Global Energy Leader
                        </h2>
                        <p className="text-gray-200">
                            Delivered intelligent lifecycle management and digital services
                            that improved asset reliability and operational efficiency.
                        </p>
                        <button className="mt-6 bg-orange-500 px-6 py-3 rounded-md">
                            Read the story
                        </button>
                    </div>

                    <img
                        src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d"
                        alt="Industrial Client Success"
                        className="rounded-xl"
                    />
                </div>
            </section>

            {/* ================= NEWS ================= */}
            {/* <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((i) => (
                            <div
                                key={i}
                                className="bg-white text-black rounded-xl overflow-hidden"
                            >
                                <img
                                    src="https://images.unsplash.com/photo-1581093458791-9f3c3900df4b"
                                    alt="Industrial Insight"
                                />
                                <div className="p-5">
                                    <span className="text-xs text-orange-600">Blog</span>
                                    <p className="mt-2 font-medium">
                                        Accelerating industrial transformation through AI and data
                                    </p>
                                    <button className="mt-3 text-orange-600 text-sm">
                                        Read the blog →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* ================= CONTACT ================= */}
            {/* <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>

                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default IndustrialIndustryLayout;
